export enum WebComponents {
  V_FRONT_PAGE = "v-front-page",
}
